import React from 'react'
import UpdateRecipeComponent from './UpdateRecipeComponent'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedRecipeData, setSelectedRecipeId, updateSelectedRecipeData } from '../../../Store/slices/recipeSlice';
import { RootState } from '../../../Store/store';
import { Box, Button, MenuItem, Modal, Select, Switch, TextField, Typography } from '@mui/material';
import { useRecipesHook } from '../../../Hooks/communicators/useRecipesHook';
import NumberInput from '../../../Components/NumberInput';
import { useTagsHook } from '../../../Hooks/communicators/useTagsHook';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

export default function UpdateRecipesPage() {
    const dispatch = useDispatch();
    const {
        allRecipes,
        selectedRecipeData,
        selectedRecipeId,
    } = useSelector((state: RootState) => state.recipe.value)
    const {
        globalTags,
    } = useSelector((state: RootState) => state.tags.value)
    const {
        fetchTags,
    } = useTagsHook();
    const [isModalOpen, setIsModalOpen] = React.useState(false)
    const [searchQuery, setSearchQuery] = React.useState('')
    const {
        recipeTypes,
        recipeTrimesters,
        handleUpdate,
        handleUpdateFileChange,
        updateUploading,
        updateProgress,
        fetchAllRecipes,
        searchRecipes,
    } = useRecipesHook();
    const handleClose = () => {
        dispatch(setSelectedRecipeData(null))
        dispatch(setSelectedRecipeId(''))
        setIsModalOpen(false)
    };
    const onClickOpen = (recipe_: any) => {
        dispatch(setSelectedRecipeData(recipe_))
        dispatch(setSelectedRecipeId(recipe_._id))
        setIsModalOpen(true)
    }
    React.useEffect(() => {
        if (searchQuery.trim() === '') {
            fetchAllRecipes();
        } else if (searchQuery.trim().length >= 3) {
            const delaySearch = setTimeout(() => {
                searchRecipes(searchQuery);
            }, 500); // 500ms debounce

            return () => clearTimeout(delaySearch);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery]);

    const dataToUpdates = [
        {
            id: 17,
            title: 'Carbs',
            key: 'recipeCarbs',
        },
        {
            id: 18,
            title: 'Protein',
            key: 'recipeProtein',
        },
        {
            id: 19,
            title: 'Fats',
            key: 'recipeFats',
        },
        {
            id: 20,
            title: 'Calories',
            key: 'recipeCalories',
        },
        {
            id: 21,
            title: 'Calcium',
            key: 'recipeCalcium',
        },
        {
            id: 1,
            title: 'Vitamin A',
            key: 'recipeVitaminA',
        },
        {
            id: 2,
            title: 'Vitamin B6',
            key: 'recipeVitaminB6',
        },
        {
            id: 3,
            title: 'Vitamin B12',
            key: 'recipeVitaminB12',
        },
        {
            id: 4,
            title: 'Vitamin C',
            key: 'recipeVitaminC',
        },
        {
            id: 5,
            title: 'Vitamin D',
            key: 'recipeVitaminD',
        },
        {
            id: 6,
            title: 'Vitamin E',
            key: 'recipeVitaminE',
        },
        {
            id: 7,
            title: 'Vitamin K',
            key: 'recipeVitaminK',
        },
        {
            id: 8,
            title: 'Cholesterol',
            key: 'recipeCholesterol',
        },
        {
            id: 9,
            title: 'Choline',
            key: 'recipeCholine',
        },
        {
            id: 10,
            title: 'Fiber',
            key: 'recipeFiber',
        },
        {
            id: 11,
            title: 'Folate (Folic Acid)',
            key: 'recipeFolicAcid',
        },
        {
            id: 12,
            title: 'Iodine',
            key: 'recipeIodine',
        },
        {
            id: 13,
            title: 'Iron',
            key: 'recipeIron',
        },
        {
            id: 14,
            title: 'Magnesium',
            key: 'recipeMagnesium',
        },
        {
            id: 15,
            title: 'Potassium',
            key: 'recipePotassium',
        },
        {
            id: 16,
            title: 'Saturated Fat',
            key: 'recipeSaturatedFat',
        },
    ];
    return (
        <div className='flex justify-center items-center flex-col'>
            <h1 className='text-2xl font-bold'>Update Recipes</h1>
            <h2 className='text-lg font-semibold my-4'>Click on the recipe to update</h2>

            {/* Search Input */}
            <div className='w-full max-w-2xl my-4 px-4'>
                <input
                    type="text"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder="Search recipes... (min. 3 characters)"
                    className='w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
                />
                {searchQuery.trim().length > 0 && searchQuery.trim().length < 3 && (
                    <p className='text-sm text-gray-500 mt-1'>Please enter at least 3 characters to search</p>
                )}
            </div>

            {
                allRecipes && allRecipes.map((recipe: any) => {
                    return (
                        <UpdateRecipeComponent
                            id={recipe._id}
                            onClick={() => onClickOpen(recipe)}
                            title={recipe.recipeName}
                            image={recipe.recipeImage}
                            isDeleted={recipe.isDeleted}
                        />
                    )
                })
            }
            {
                isModalOpen === true && selectedRecipeId !== '' && selectedRecipeData !== null && (
                    <Modal open={isModalOpen} onClose={handleClose}>
                        <Box
                            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 overflow-scroll bg-white p-6 rounded-lg shadow-lg"
                            sx={{
                                width: 750,
                                minHeight: 400,
                                maxHeight: 800,
                            }}
                        >
                            <Typography variant="h6" className="mb-4">
                                Edit Recipe - {selectedRecipeData.recipeName}
                            </Typography>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Recipe Name
                                </Typography>
                                <TextField
                                    label='Recipe Name'
                                    variant='filled'
                                    style={{ width: '450px', marginBottom: '32px' }}
                                    type="text"
                                    placeholder='Recipe Name'
                                    value={selectedRecipeData.recipeName}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "recipeName", value: e.target.value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Recipe Method
                                </Typography>
                                <div style={{ width: '600px', marginBottom: '16px', marginTop: '16px' }}>
                                    <ReactQuill
                                        theme="snow"
                                        value={selectedRecipeData.recipeMethod}
                                        onChange={(value) => dispatch(updateSelectedRecipeData({ key: "recipeMethod", value }))}
                                        placeholder="Enter recipe method with rich formatting..."
                                        style={{
                                            height: '250px',
                                            marginBottom: '50px'
                                        }}
                                        modules={{
                                            toolbar: [
                                                [{ 'header': [1, 2, 3, false] }],
                                                ['bold', 'italic', 'underline'],
                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                ['clean']
                                            ],
                                        }}
                                        formats={[
                                            'header',
                                            'bold', 'italic', 'underline',
                                            'list', 'bullet'
                                        ]}
                                    />
                                </div>
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 16
                                }}>
                                    Ingredients
                                </Typography>
                                <div style={{ width: '600px', marginBottom: '16px', marginTop: '32px' }}>
                                    <ReactQuill
                                        theme="snow"
                                        value={selectedRecipeData.recipeIngredients && selectedRecipeData.recipeIngredients[0] ? selectedRecipeData.recipeIngredients[0] : ''}
                                        onChange={(value) => {
                                            const updatedIngredients = [...(selectedRecipeData.recipeIngredients || [])];
                                            updatedIngredients[0] = value;
                                            dispatch(updateSelectedRecipeData({
                                                key: "recipeIngredients",
                                                value: updatedIngredients
                                            }));
                                        }}
                                        placeholder="Enter ingredients with rich formatting..."
                                        style={{
                                            height: '250px',
                                            marginBottom: '50px',
                                        }}
                                        modules={{
                                            toolbar: [
                                                ['bold', 'italic', 'underline'],
                                                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                                                ['clean']
                                            ],
                                        }}
                                        formats={[
                                            'bold', 'italic', 'underline',
                                            'list', 'bullet'
                                        ]}
                                    />
                                </div>


                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 16
                                }}>
                                    Recipe Type
                                </Typography>
                                <Select
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    value={selectedRecipeData.recipeType}
                                    label="Type"
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "recipeType", value: e.target.value }))}
                                >
                                    {
                                        recipeTypes.map((option: any) => {
                                            return (
                                                <MenuItem value={option.value}>{option.title}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </div>

                            {/* Recipe Image Upload Section */}
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Recipe Image
                                </Typography>

                                {/* Current Image Preview */}
                                {selectedRecipeData.recipeImage && (
                                    <div style={{ marginBottom: '16px' }}>
                                        <Typography variant="body2" color="text.secondary" gutterBottom>
                                            Current Image:
                                        </Typography>
                                        <img
                                            src={selectedRecipeData.recipeImage}
                                            alt="Current Recipe"
                                            style={{
                                                width: '200px',
                                                height: '150px',
                                                objectFit: 'cover',
                                                borderRadius: '8px',
                                                border: '2px solid #e0e0e0'
                                            }}
                                        />
                                    </div>
                                )}

                                {/* File Upload Input */}
                                <TextField
                                    variant='filled'
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    type="file"
                                    onChange={handleUpdateFileChange}
                                    inputProps={{ accept: 'image/*' }}
                                />

                                {/* Upload Progress */}
                                {updateUploading && (
                                    <div style={{ marginBottom: '16px' }}>
                                        <Typography variant="body2" color="primary">
                                            Image uploading... {Math.round(updateProgress)}%
                                        </Typography>
                                        <div style={{
                                            width: '450px',
                                            height: '4px',
                                            backgroundColor: '#e0e0e0',
                                            borderRadius: '2px',
                                            overflow: 'hidden',
                                            marginTop: '8px'
                                        }}>
                                            <div style={{
                                                width: `${updateProgress}%`,
                                                height: '100%',
                                                backgroundColor: '#1976d2',
                                                transition: 'width 0.3s ease'
                                            }} />
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Recipe Trimester
                                </Typography>
                                <Select
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    value={selectedRecipeData.recipeTrimester}
                                    label="Trimester"
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "recipeTrimester", value: e.target.value }))}
                                >
                                    {
                                        recipeTrimesters.map((option: any) => {
                                            return (
                                                <MenuItem value={option.value}>{option.title}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Preparation Time
                                </Typography>
                                <NumberInput
                                    marginTop={0}
                                    width='450px'
                                    value={selectedRecipeData.recipePreparationTime}
                                    onChange={(value) => dispatch(updateSelectedRecipeData({ key: "recipePreparationTime", value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Cook Time
                                </Typography>
                                <NumberInput
                                    marginTop={0}
                                    width='450px'
                                    value={selectedRecipeData.recipeCookTime}
                                    onChange={(value) => dispatch(updateSelectedRecipeData({ key: "recipeCookTime", value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Serves
                                </Typography>
                                <NumberInput
                                    marginTop={0}
                                    width='450px'
                                    value={selectedRecipeData.recipeServes}
                                    onChange={(value) => dispatch(updateSelectedRecipeData({ key: "recipeServes", value }))}
                                />
                            </div>
                            <div>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                    marginBottom: 2,
                                    marginTop: 4
                                }}>
                                    Tags
                                </Typography>
                                <Select
                                    multiple
                                    style={{ width: '450px', marginBottom: '16px' }}
                                    value={selectedRecipeData.recipeTags}
                                    label="Recipe Tag"
                                    // onChange={(e: any) => setRecipeTags(e.target.value)}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "recipeTags", value: e.target.value }))}
                                >
                                    {
                                        globalTags.map((option: any) => {
                                            return (
                                                <MenuItem value={option}>{option}</MenuItem>
                                            )
                                        })
                                    }
                                </Select>
                                <Button
                                    onClick={() => fetchTags()}
                                    style={{ width: '450px', marginBottom: '16px', marginTop: '16px' }}
                                    variant='contained'
                                    color='primary'>
                                    Fetch Tags Manually (If not updated)
                                </Button>
                            </div>
                            <div className='w-full flex flex-row justify-start items-center my-8'>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}>
                                    Premium:
                                </Typography>
                                <Switch
                                    checked={selectedRecipeData.isPremium}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "isPremium", value: e.target.checked }))}
                                />
                            </div>
                            <div className='w-full flex flex-row justify-start items-center my-8'>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}>
                                    Deleted:
                                </Typography>
                                <Switch
                                    checked={selectedRecipeData.isDeleted}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "isDeleted", value: e.target.checked }))}
                                />
                            </div>
                            <div className='w-full flex flex-row justify-start items-center my-8'>
                                <Typography sx={{
                                    fontSize: 20,
                                    fontWeight: 600,
                                }}>
                                    Priority:
                                </Typography>
                                <Switch
                                    checked={selectedRecipeData.isPriority}
                                    onChange={(e) => dispatch(updateSelectedRecipeData({ key: "isPriority", value: e.target.checked }))}
                                />
                            </div>
                            <div>
                                {
                                    dataToUpdates.map((data: any) => {
                                        return (
                                            <div>
                                                <Typography sx={{
                                                    fontSize: 20,
                                                    fontWeight: 600,
                                                    marginBottom: 2,
                                                    marginTop: 4
                                                }}>
                                                    {data.title}
                                                </Typography>
                                                <NumberInput
                                                    marginTop={0}
                                                    width='450px'
                                                    value={
                                                        selectedRecipeData[data.key]
                                                    }
                                                    onChange={(value) => dispatch(updateSelectedRecipeData({ key: data.key, value }))}
                                                />
                                            </div>
                                        )

                                    })
                                }
                            </div>
                            <div className='flex justify-between w-[300px] mt-4 p-4'>
                                <Button
                                    disabled={
                                        selectedRecipeData._id === '' ||
                                        selectedRecipeData.recipeName === '' ||
                                        selectedRecipeData.recipeType === '' ||
                                        selectedRecipeData.recipeTrimester === '' ||
                                        selectedRecipeData.recipeImage === ''
                                    }
                                    variant="contained"
                                    color="primary"
                                    onClick={handleUpdate}
                                    className="mt-4">
                                    Update
                                </Button>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={handleClose}
                                    className="mt-4">
                                    Close
                                </Button>
                            </div>
                        </Box>
                    </Modal>
                )
            }
        </div >
    )
}
